<template>
    <section class="medical-info">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-lg-4">
                    <div class="medical-info-single bg-cover">
                        <h6 class="medical-info-title">Helios Med</h6>
                        <div class="medical-info-body">
                            <p>Laborator Helios është një laborator imunologjik - hormonal drejtuar nga mjek specialist ku mund të gjeni teknologjinë më të fundit, shërbimin e kualifikuar, saktësinë dhe profesionalizmin.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="medical-info-single medical-info-midle">
                        <h6 class="medical-info-title">Orari</h6>
                        <ul class="medical-info-body working-hour">
                            <li>E Hene - E Premte:<span>08.00 - 16.00</span></li>
                            <li>E Shtunë: <span>08.00 - 14.30</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="medical-info-single">
                        <h6 class="medical-info-title">Teknologji</h6>
                        <div class="medical-info-body">
                            <p>Ne operojme me fjalën më fundit të teknologjisë, me aparatura e reagent me sistem automatik. Informatizim i plotë i regjistrimit të të dhënave dhe rezultateve.</p>
                            <a href="#" class="btn btn-round">Lexo më shumë</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'MedicalInfo',
    metaInfo:{
        title: 'Analiza me teknologjinë më të fundit', 
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/medical-info.scss';
</style>
